import { createContext } from 'react'

import { TrainingsContextValue } from './TrainingsContext.types'

export const TrainingsContext = createContext<TrainingsContextValue | undefined>(undefined)
